import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import CollectionItem from "../../layouts/CollectionItem/CollectionItem";

const CollectionItemPage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <CollectionItem />
        </>
        
    )
}

export default CollectionItemPage;